import { useTranslation } from 'react-i18next';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import PeopleIcon from '@material-ui/icons/People';

import { CategoryTilesController, IconTile } from '@Components';
import { Link } from '@Components/common';
import { formatNumber } from '@Helpers';

import { ProfileSectionHeader } from '../ProfilePage';
import styles from './AboutSection.module.scss';
import Linkify from 'linkify-react';

export interface AboutSectionProps {
  description?: string;
  organizationType?: string;
  companyNumber?: string;
  charityNumber?: string;
  setupYear?: number;
  legalStructure?: string;
  categoriesIds?: number[];
  totalAmount?: number;
  totalBeneficiaries?: number;
}

export const AboutSection = ({
  description,
  organizationType,
  companyNumber,
  charityNumber,
  setupYear,
  legalStructure,
  categoriesIds,
  totalAmount,
  totalBeneficiaries,
}: AboutSectionProps) => {
  const { t } = useTranslation('profilePage');
  const { t: tFund } = useTranslation('fund');
  return (
    <>
      <div className={styles.iconTiles}>
        {totalAmount && (
          <IconTile
            labelText={tFund('details_page.total_amount')}
            valueText={tFund('common:currency_format', { amount: totalAmount })}
          >
            <BusinessCenterIcon />
          </IconTile>
        )}
        {totalBeneficiaries && totalBeneficiaries !== 0 && (
          <IconTile
            labelText={tFund('details_page.beneficiaries')}
            valueText={formatNumber(totalBeneficiaries) || ''}
          >
            <PeopleIcon />
          </IconTile>
        )}
      </div>

      <ProfileSectionHeader className={styles.smallMargin}>{t('who_we_are')}</ProfileSectionHeader>

      {description && <h3 className={styles.aboutItemHeader}>{t('description_header')}</h3>}
      <p className={styles.aboutItem}>
        <Linkify>{description}</Linkify>
      </p>

      {organizationType && (
        <h3 className={styles.aboutItemHeader}>{t('organization_type_header')}</h3>
      )}
      <p className={styles.aboutItem}>{organizationType}</p>

      {companyNumber && <h3 className={styles.aboutItemHeader}>{t('company_number_header')}</h3>}
      <p className={styles.aboutItem}>{companyNumber}</p>

      {charityNumber && <h3 className={styles.aboutItemHeader}>{t('charity_number_header')}</h3>}
      <p className={styles.aboutItem}>{charityNumber}</p>

      {setupYear && <h3 className={styles.aboutItemHeader}>{t('setup_year_header')}</h3>}
      <p className={styles.aboutItem}>{setupYear}</p>

      {legalStructure && <h3 className={styles.aboutItemHeader}>{t('legal_structure_header')}</h3>}
      <p className={styles.aboutItem}>{legalStructure}</p>

      <ProfileSectionHeader>{t('focus_areas')}</ProfileSectionHeader>
      <CategoryTilesController categoriesIds={categoriesIds} />
    </>
  );
};
